export interface SubtitleReorganizeInput {
  maxWordsPerLine: number;
  removePunctuation?: boolean;
}

export function buildSubtitleReorganizeOptions(input: SubtitleReorganizeInput) {
  return {
    maxWordsPerLine: input.maxWordsPerLine,
    maxSecondsPerLine: 20.0,
    maxCharactersPerLine: 50,
    cutPhrases: false,
    removePunctuation: input.removePunctuation ?? false,
  };
}
